module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/flag-d9433c5ca21efca18cf2f7b04afeff18.svg";